import FeatureFlagService from "@emcd-shared/feature-flag-service/feature-flag.service.js";

// Флаг из Unleash (проект default); при ошибке сервиса считаем выключенным
export const isFlagEnabled = async (flag) => {
  try {
    const featureFlagService = await FeatureFlagService.init("default");
    return featureFlagService.isEnabled(flag);
  } catch (error) {
    console.error(`Error checking ${flag} flag:`, error);
    return false;
  }
};
